import { useLocation } from 'react-router-dom';

export function useIsPartnerAffiliate() {
  const location = useLocation();

  const isPathBased = () => {
    const hasRefQuery = new URLSearchParams(location.search).has('ref');
    const match = location.pathname.match(/\/partners\/([^/?#]+)/);
    return Boolean(match && !hasRefQuery);
  };

  return isPathBased();
}
